import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { GlobalProvider } from "../../providers/global/global";
 
//let this.global.apiUrl = 'http://api.picmasters.de.w016f694.kasserver.com/api/';
 // let apiUrl = 'https://api.picmasters.de/api/';
  // let apiUrl = 'http://plentyclip.apps/api/';


@Injectable()
export class AuthProvider {
 
  public token: any;
 
  constructor(public http: Http, public storage: Storage, public global: GlobalProvider) {
 
  }
 
  checkAuthentication(){
 
    return new Promise((resolve, reject) => {
 
        //Load token if exists
        this.storage.get('token').then((value) => {
 			console.log('TOKEN FROM checkAuthentication()', value);
            this.token = value;
 
            let headers = new Headers();
            headers.append('Authorization', 'Bearer ' + this.token);
 			// AUTH CHECK!
            this.http.get(this.global.apiUrl+'orders', {headers: headers})
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
 
        });        
 
    });
 
  }
 
  createAccount(details){
 
    return new Promise((resolve, reject) => {
 
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
 
        this.http.post(this.global.apiUrl+'register', JSON.stringify(details), {headers: headers})
          .subscribe(res => {
 
            let data = res.json();
            this.token = data.token;
            this.storage.set('token', data.token);
            resolve(data);
 
          }, (err) => {
            reject(err);
          });
 
    });
 
  }
 
  login(credentials){
 
    return new Promise((resolve, reject) => {
        
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');

        //headers.append('Content-Type', 'application/json');
 
        this.http.post(this.global.apiUrl+'login', JSON.stringify(credentials), {headers: headers})
          .subscribe(res => {
 			
          	// if(this.responseData.data.api_token){
           //      console.log('TOKEN AVAILALBE:', this.responseData.data.api_token)
           //    this.storage.set('token', this.responseData.data.api_token);
           //    this.navCtrl.setRoot('LoginPage');

            let data = res.json();

            this.token = data.token;
            this.storage.set('token', data.data.api_token);
            console.log("Auth Result data:", data.data);
            this.storage.set('has_stream', data.data.userData.has_stream);
            this.global.has_stream = data.data.userData.has_stream;
            this.global.has_crm = data.data.userData.has_crm;
            this.global.is_partner = data.data.userData.is_partner;
            this.global.is_worker = data.data.userData.is_worker;
            this.storage.set('is_partner', data.data.userData.is_partner);
            this.storage.set('has_crm', data.data.userData.has_crm);
            this.storage.set('is_worker', data.data.userData.is_worker);
            resolve(data);
 
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
 
    });
 
  }
 
  logout(){
    this.storage.set('token', '');
  }
 
}


// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts